export function postsPagination(){
    $(window).on("load", function () {
        let $holderPosts = $('.posts-wrap');

        $holderPosts.on('click', '.pagination a', function (e) {
            e.preventDefault();

            let $holderCategoryPosts = $(this).closest('.ajax-holder-posts');

            let data = {
                'action': 'pagination_posts',
                'type': $holderCategoryPosts.attr('data-type'),
                'category': $holderCategoryPosts.attr('data-category'),
                'tag': $holderCategoryPosts.attr('data-tag'),
                'paged': $(this).attr('data-num')
            };

            $.ajax({
                url: ajaxvars.ajaxurl,
                data: data,
                type: 'POST',
                success: function (response) {
                    $holderCategoryPosts.html(response);
                },
            });
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/postsPagination.js